import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Company } from 'app/models';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ClosedBranchDialogComponent } from '../../dialogs/closed-branch-dialog/closed-branch-dialog.component';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-company-branches',
  templateUrl: './company-branches.component.html',
  styleUrls: ['./company-branches.component.scss']
})
export class CompanyBranchesComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = [
    'name',
    'address',
    'sectorNumber',
    'location',
    'employeeCount',
    'branchAdmins'
  ];

  @Input() branches: Subject<Company[]>;
  companyId: string;
  public companyBranches: Company[]
  companyBranchesDataSource =  new MatTableDataSource([]);
  public branchList: Company[];
  private onDestroy$ = new Subject<void>();
  queryString: string;
  loading: boolean;
  noRecordFound: boolean;
  public status:string;
  message = 'No_Branches_Found'
  constructor(private _router: Router, private route: ActivatedRoute,private dialog:MatDialog) {}

  ngOnInit() {
    this.companyId = this.route.snapshot.params['id'];
    this.branches.pipe(takeUntil(this.onDestroy$)).subscribe(companies => {
      this.companyBranches = companies;
      this.branchList = companies;
      this.companyBranchesDataSource.data = companies;
      this.companyBranchesDataSource.paginator = this.paginator;
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(null);
  }

  handleRowClick(companyBranch: any): void {
    this._router.navigate(['/company/branches', companyBranch.accountId], {
      queryParams: { companyId: this.companyId ,companyStatus:companyBranch.status }
    });
       if(this.isEqual(companyBranch.status, "Inactive")){
      const dialogRef = this.dialog.open(ClosedBranchDialogComponent, {
        width: '600px',
        data :{content : 'COMPANY_BRANCHES.closedbranch_dialog'}
      });
      dialogRef.afterClosed().subscribe(() => {
      });
    };
  }

  navigateToBranchAdmins(companyBranch : any) :void {
    this._router.navigate(['/company', this.companyId,'branch',companyBranch.accountId,'admins']);
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    if (this.queryString.length >= Number(environment.minimumSearchLength)) {
      this.companyBranches = this.branchList.filter(a =>
        a.name.toLowerCase().includes(this.queryString.toLowerCase().trim()) ||
        a.sectorNumber.toLowerCase().includes(this.queryString.toLowerCase().trim()) ||
        a.location?.toLowerCase().includes(this.queryString.toLowerCase().trim())
      );
      this.noRecordFound = this.companyBranches.length === 0;
    } else {
      this.companyBranches = this.branchList;
      this.noRecordFound = false;
    }
    this.companyBranchesDataSource.data = this.companyBranches;
    setTimeout(() => {
      this.companyBranchesDataSource.paginator = this.paginator;
    }, 10);
  }

  isEqual(value1 : string, value2: string) : boolean{
    if(!value1 || !value2) return false;
    return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
  }
}
